import { Box, Button, HStack, Input, Text, Tooltip } from "@chakra-ui/react";
import React, { ChangeEvent, useRef } from "react";

type Props = {
  setPreviewUrl?: (path: string | null) => void;
  formik: any;
  name: string;
  accept?: string;
};

export default function FileUploader({
  setPreviewUrl,
  formik,
  name,
  accept,
}: Props) {
  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];

    if (setPreviewUrl) {
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewUrl(reader.result as string);
        };
        reader.readAsDataURL(file);
      } else {
        setPreviewUrl(null);
      }
    }

    const files: FileList | null = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      formik.setFieldValue(name, [file]);
    }
    // console.log(files);
  };

  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <>
      <Input
        ref={inputRef}
        display={"none"}
        name={name}
        type="file"
        accept={accept || ".*"}
        onChange={handleImageChange}
        mb={4}
      />

      <Button
        px={0}
        w={"100%"}
        fontWeight={400}
        variant={"ghost"}
        className="btn"
        gap={0}
        border={"1px solid var(--divider3)"}
        boxShadow={formik.errors[name] ? "0 0 0px 1px var(--red)" : ""}
        borderRadius={8}
        cursor={"pointer"}
        _focus={{ boxShadow: "0 0 0px 2px var(--p500)" }}
        onClick={() => {
          if (inputRef.current) {
            inputRef.current.click();
          }
        }}
      >
        <HStack gap={0} w={"100%"}>
          <HStack
            h={"40px"}
            flexShrink={0}
            px={4}
            py={2}
            borderRadius={"8px 0 0 8px"}
            bg={"var(--divider)"}
          >
            <Text fontSize={[12, null, 14]}>Pilih File</Text>
          </HStack>

          <Box px={4} py={2}>
            <Tooltip label={formik?.values?.konten?.[0]?.name}>
              <Text
                noOfLines={1}
                fontSize={[12, null, 14]}
                whiteSpace={"normal"}
                textAlign={"left"}
              >
                {formik?.values?.[name]?.[0]?.name ||
                  "Pilih file yang ingin diunggah"}
              </Text>
            </Tooltip>
          </Box>
        </HStack>
      </Button>
    </>
  );
}
